__turbopack_context__.v({
  "input": "mantineNumberInput-module-scss-module__G48VxG__input",
});
